(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TRANSITION_MS = 550;
    var SLIDE_DISTANCE = 6; /* percent */

    function syncControls(state) {
      state.controls.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-index'), 10);
        var isActive = idx === state.current;
        el.classList.toggle('is-active', isActive);
        el.setAttribute('aria-selected', isActive ? 'true' : 'false');
        el.tabIndex = isActive ? 0 : -1;

        var navItem = el.closest('.lookbook-gallery__nav-item');
        if (navItem) navItem.classList.toggle('is-active', isActive);
      });
    }

    function setActiveIndex(state, index, options) {
      var opts = options || {};
      var count = state.slides.length;
      if (!count) return;

      var nextIndex = ((index % count) + count) % count;

      if (nextIndex === state.current) {
        if (opts.focusEl) opts.focusEl.focus();
        return;
      }

      var direction = nextIndex > state.current ? 1 : -1;
      var outgoing = state.slides[state.current];
      var incoming = state.slides[nextIndex];

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        incoming.classList.add('is-active');
        incoming.setAttribute('aria-hidden', 'false');
        if (outgoing && outgoing !== incoming) {
          outgoing.classList.remove('is-active');
          outgoing.setAttribute('aria-hidden', 'true');
        }
      } else {
        /* Phase 1: place the incoming slide off-stage instantly, no transition */
        incoming.style.transition = 'none';
        incoming.style.visibility = 'visible';
        incoming.style.opacity = '0';
        incoming.style.transform = 'translateX(' + direction * SLIDE_DISTANCE + '%)';
        void incoming.offsetWidth; /* force reflow */
        incoming.style.transition = '';

        /* Phase 2: animate incoming in, outgoing out, next frame */
        window.requestAnimationFrame(function () {
          incoming.classList.add('is-active');
          incoming.setAttribute('aria-hidden', 'false');
          incoming.style.opacity = '1';
          incoming.style.transform = 'translateX(0)';

          if (outgoing && outgoing !== incoming) {
            outgoing.classList.remove('is-active');
            outgoing.setAttribute('aria-hidden', 'true');
            outgoing.style.opacity = '0';
            outgoing.style.transform = 'translateX(' + -direction * SLIDE_DISTANCE + '%)';
          }
        });

        window.setTimeout(function () {
          [incoming, outgoing].forEach(function (slide) {
            if (!slide) return;
            slide.style.transition = 'none';
            slide.style.transform = '';
            slide.style.opacity = '';
            slide.style.visibility = '';
            void slide.offsetWidth;
            slide.style.transition = '';
          });
        }, TRANSITION_MS);
      }

      state.current = nextIndex;
      syncControls(state);

      if (opts.focusEl) {
        opts.focusEl.focus();
      }
    }

    function bindControl(state, el) {
      var idx = parseInt(el.getAttribute('data-index'), 10);
      if (isNaN(idx)) return;

      var groupAttr = el.hasAttribute('data-lookbook-nav') ? 'data-lookbook-nav' : 'data-lookbook-tab';

      el.addEventListener('click', function () {
        setActiveIndex(state, idx);
      });

      el.addEventListener('keydown', function (event) {
        var group = state.controls.filter(function (c) {
          return c.hasAttribute(groupAttr);
        });
        var focusNeighbor = function (targetIndex) {
          var match = group.find(function (c) {
            return parseInt(c.getAttribute('data-index'), 10) === targetIndex;
          });
          setActiveIndex(state, targetIndex, { focusEl: match || el });
        };

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            event.preventDefault();
            focusNeighbor(idx + 1);
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            event.preventDefault();
            focusNeighbor(idx - 1);
            break;
          case 'Home':
            event.preventDefault();
            focusNeighbor(0);
            break;
          case 'End':
            event.preventDefault();
            focusNeighbor(state.slides.length - 1);
            break;
        }
      });
    }

    function initLookbookGallery(root) {
      if (!root || root.dataset.lookbookReady === 'true') return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lookbook-slide]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lookbook-tab]'));
      var navTabs = Array.prototype.slice.call(root.querySelectorAll('[data-lookbook-nav]'));

      if (!slides.length || !tabs.length) return;

      root.dataset.lookbookReady = 'true';

      var initialIndex = 0;
      slides.forEach(function (slide, i) {
        if (slide.classList.contains('is-active')) initialIndex = i;
      });

      var state = {
        slides: slides,
        controls: tabs.concat(navTabs),
        current: initialIndex
      };

      state.controls.forEach(function (el) {
        bindControl(state, el);
      });
    }

    function initAll(scope) {
      var context = scope && scope.querySelectorAll ? scope : document;
      context.querySelectorAll('[data-lookbook-gallery]').forEach(initLookbookGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
